export default __webpack_public_path__ + "0cfd83f6ef2b5679970bea2d330e8aaa.jpg";